// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2OYtk","footer":"ReportModalFilter_footer__wVLwA"};